import React, { useContext, useLayoutEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';

import { bem } from 'helpers/class-name';
import Button from 'components/Button';
import { SvgLeftArrow } from 'components/Svgs';
import { BackNavLinkContext, BackNavRegistrationContext } from './Contexts';

const { element } = bem('app__backnav-link');

const HistoryBackButton = () => {
  const navigate = useNavigate();

  function handleGoBack() {
    navigate(-1);
  }

  return (
    <Button onClick={handleGoBack} styled={false}>
      <SvgLeftArrow />
    </Button>
  );
};

const Element = ({ to, useHistoryHook }) => {
  if (!useHistoryHook) {
    return (
      <Link className={element()} to={to}>
        <SvgLeftArrow />
      </Link>
    );
  }

  return <HistoryBackButton />;
};

Element.propTypes = {
  to: PropTypes.string,
  useHistoryHook: PropTypes.bool,
};

const BackNavLink = ({ to, useHistoryHook }) => {
  const hostRef = useContext(BackNavLinkContext);
  const registration = useContext(BackNavRegistrationContext);
  const [host, setHost] = useState(null);

  useLayoutEffect(() => {
    setHost(hostRef ? hostRef.current : null);
  }, [hostRef]);

  useLayoutEffect(() => {
    if (!host || !registration) {
      return undefined;
    }
    registration.register();
    return () => registration.unregister();
  }, [host, registration]);

  if (!host) {
    return null;
  }

  return ReactDOM.createPortal(<Element to={to} useHistoryHook={useHistoryHook} />, host);
};

BackNavLink.propTypes = {
  to: PropTypes.string,
  useHistoryHook: PropTypes.bool,
};

export default BackNavLink;
